import React from 'react';
import background from '../../assets/crab.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoCrab extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="OCEANS"
        description="Crabs"
        paragraph="The Dungeness crab, also known as Metacarcinus magister, is a species of crab that inhabits eelgrass beds and water bottoms on the Pacific Northwest. It is one of the most profitable fisheries on the west coast."
        background={background}
     />
  
  );
 }
}   

export default InfoCrab;